import React from "react";
import classNames from "classnames";

import Pages from "components/common/Pages";
import Details from "components/Pages/Transactions/Details";
import DisputeFlow from "components/Pages/Transactions/DisputeFlow";
import DisputeFlowInternal from "components/Pages/Transactions/DisputeFlowInternal";
import DisputeSuccess from "components/Pages/Transactions/DisputeSuccess";

const DisputeModal = ({
  closeModal,
  submitDispute,
  disputeReasons,
  addTransactionTags,
  removeTransactionTag,
  row,
  user,
  internal = false
}) => {
  const disputeModalClasses = classNames(
    "py-8 px-12 max-h-screen overflow-auto",
    {
      "pb-10": row.original.dispute_status && row.original.settled_at
    }
  );

  const DisputeComponent = internal ? DisputeFlowInternal : DisputeFlow;

  return (
    <div style={{ backgroundColor: "#FAFAFA" }} className={disputeModalClasses}>
      <Pages>
        <Details
          row={row}
          close={closeModal}
          style={{ width: "450px", minHeight: "350px", maxHeight: "550px" }}
          addTransactionTags={addTransactionTags}
          removeTransactionTag={removeTransactionTag}
        />
        <DisputeComponent
          data={{ user, transaction: { ...row.original } }}
          close={closeModal}
          submitDispute={submitDispute}
          reasons={disputeReasons}
          style={{ width: "350px", height: "auto" }}
        />
        <DisputeSuccess
          close={closeModal}
          style={{ width: "350px", height: "auto" }}
        />
      </Pages>
    </div>
  );
};

export default DisputeModal;
